function isRecord(value: unknown): value is Record<string, unknown> {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}

/** Normalize the two current backend validation response formats for known fields. */
export function getFieldErrors(data: unknown, fields: readonly string[]): Record<string, string[]> {
    const result: Record<string, string[]> = Object.create(null);
    const allowed = new Set(fields.filter(field => !['__proto__', 'constructor', 'prototype'].includes(field)));
    if (!isRecord(data)) return result;
    let errors = data.errors ?? data.errorList;
    if (isRecord(errors) && typeof errors.bad_request === 'string') {
        try { errors = JSON.parse(errors.bad_request); }
        catch (_) { return result; }
    }
    const append = (field: string, value: unknown): void => {
        if (!allowed.has(field)) return;
        const values: unknown[] = Array.isArray(value) ? value : [value];
        const messages = values.filter((message): message is string => typeof message === 'string' && message.trim().length > 0);
        if (messages.length) result[field] = [...(result[field] ?? []), ...messages];
    };
    if (Array.isArray(errors)) {
        for (const error of errors) {
            if (isRecord(error) && typeof error.field === 'string') append(error.field, error.message);
        }
    } else if (isRecord(errors)) {
        for (const field of Object.keys(errors)) append(field, errors[field]);
    }
    return result;
}
